import React  from 'react';
import BasicObjectsSelector from './BasicObjectsSelector/BasicObjectsSelector';
import { connect } from "react-redux";
import {
	selectSymbol,
	setSchematicListElement,
	setSymbolTypes
} from "../../store/Schematic_store/actions";

import SymbolPreviewContainer from './SymbolPreviewContainer/SymbolPreviewContainer';

import SelectItemContainer from "./Select-ItemContainer/Select-ItemContainer";

class LeftToolbar extends React.PureComponent {
    get renderComponent() {
        const {sidebarVisible, graph} = this.props;
        if (sidebarVisible) return <SymbolPreviewContainer {...this.props}/>
        else if (graph) return <SelectItemContainer{...this.props}/>
        else return null;
    }

    render() {
        return (
            <div className={"body_left_div"}>
                <BasicObjectsSelector graph={this.props.graph}/>
                {this.renderComponent}

				</div>
		)
	}
}

const mapStateToProps = ({schematicReducers} ) => {
	return {
		selectedSymbol: schematicReducers.selectedSymbol,
		previewSymbol: schematicReducers.previewSymbol,
		graph: schematicReducers.graph.value,
		schematicList: schematicReducers.schematicList,
		symbolsTypes: schematicReducers.symbolsTypes,
		sidebarVisible: schematicReducers.sidebarVisible
	};
};

function mapDispatchToProps( dispatch ) {
	return {
		setSchematicElement: ( schematicUpdated ) => {
			dispatch(setSchematicListElement(schematicUpdated))
		},
		selectedCurrentSymbol: ( symbol ) => {
			dispatch(selectSymbol(symbol))
		},
		setSymbolTypes: ( symbolTypes ) => {
			dispatch(setSymbolTypes(symbolTypes))
		}
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(LeftToolbar);
